import SectionHeading from "@/components/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { imgSrc } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Partnership() {
  const { content } = useContent();
  const P = content.partnership;

  return (
    <div data-testid="partnership-page" className="pt-32">
      <SEO path="/partnership" title="City BOND ACP · Authorised Distributor Chennai"
        description="Among India's largest distributors of City BOND Premium ACP. Buy fire-rated ACP and HPL panels with PVDF coating, 100+ shades, architectural facade applications. Authorised City BOND partner since 2021." />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 items-center pb-16">
        <div className="lg:col-span-7">
          <SectionHeading eyebrow={P.eyebrow} title={P.title} sub={P.body} />
          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {P.bullets.map((t) => (
              <div key={t} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-[#D4AF37] mt-0.5" />
                <span className="text-sm text-[#1A1A1A] font-medium">{t}</span>
              </div>
            ))}
          </div>
          <Link to="/contact" className="mt-10 inline-flex items-center gap-2 btn-charcoal px-7 py-4 text-xs tracking-widest uppercase font-semibold" data-testid="partnership-cta">
            Request ACP Quote <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={imgSrc(P.image)} alt="City BOND ACP" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-[#0F0F10] text-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
          <SectionHeading invert eyebrow="Why City BOND" title="A premium ACP brand trusted by India's architects." align="center" />
          <div className="grid md:grid-cols-3 gap-6 mt-14">
            {P.features.map((c) => (
              <div key={c.title} className="border border-white/10 p-7 hover:border-[#D4AF37] transition-colors">
                <div className="font-display text-xl">{c.title}</div>
                <p className="mt-2 text-sm text-[#9CA3AF]">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid md:grid-cols-3 gap-5">
          {P.gallery.map((g, i) => (
            <img key={i} src={imgSrc(g)} alt="" className="aspect-[3/4] object-cover w-full" />
          ))}
        </div>
      </section>
    </div>
  );
}
